export const getTrack = state => state.trackID;



// WEBPACK FOOTER //
// ./src/redux/track/selectors.js